module.exports = require("core-js/modules/es.array.from.js");